'use client'
import { useAIFeatureEnableManager } from '@/src/hooks/AIFeatureEnableManager'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'

interface FlightSearchTabsProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
    showVisaTab?: boolean
    showFlightsHotelsTab?: boolean
    initialAiEnabled?: boolean
}

export const FlightSearchTabs = ({
    isMobile,
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam,
    showVisaTab = false,
    showFlightsHotelsTab = false,
    initialAiEnabled
}: FlightSearchTabsProps) => {
    const { homeAISearch } = useAIFeatureEnableManager(initialAiEnabled)
    const showAiSearchTab = homeAISearch
    const showThirdTab = showVisaTab || showFlightsHotelsTab
    const flightsTabIndex = 0
    const hotelsTabIndex = flightsTabIndex + 1
    const thirdTabIndex = hotelsTabIndex + 1

    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()
    const t = useTranslations('header')

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (newValue === hotelsTabIndex) {
            const hotelsHref = isCleartrip() ? '/hotels' : `/${locale}/hotels`
            window.location.href = hotelsHref
        } else if (showThirdTab && newValue === thirdTabIndex) {
            const thirdHref = showVisaTab ? '/visa' : `/${locale}/flights-hotels`
            window.location.href = thirdHref
        } else {
            setTabValue(newValue)
        }
    }

    return (
        <FlightSearchTabsComponent
            t={t}
            tabValue={tabValue}
            onTabChange={handleTabChange}
            isMobile={isMobile}
            serverRecentSearches={serverRecentSearches}
            hideMulticity={hideMulticity}
            fromParam={fromParam}
            toParam={toParam}
            showVisaTab={showVisaTab}
            showFlightsHotelsTab={showFlightsHotelsTab}
            showAiSearchTab={showAiSearchTab}
        />
    )
}
